import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import strings from "translate/language";
import { seo } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import Select from "react-select";
import {
  getReportPropertyList,
  getReportEmployeeList,
} from "reduxStore/action/reportActions";
import { isEmpty } from "utils/utils";
import { addUserAnnouncement } from "../../reduxStore/action/announcementActions";

const UserAnnouncement = () => {
  const dispatch = useDispatch();
  const [formVaild, setFormVaild] = useState({});
  const [form, setForm] = useState({});
  const [sitePropertyList, setSitePropertyList] = useState([]);
  const [getchannelPartnerList, setchannelPartnerList] = useState([]);
  const [userList, setUserList] = useState([]);
  const ReportListSelector = useSelector((state) => state.report);

  useEffect(() => {
    seo({
      title: "Report Listing",
      metaDescription: "All Report list",
      canonicalLink: window.location.href,
    });
  }, []);

  useEffect(() => {
    dispatch(getReportPropertyList({ limit: 10, offset: 0 }));
    dispatch(getReportEmployeeList({ limit: 10, offset: 0, user_type: 1 }));
    dispatch(getReportEmployeeList({ limit: 10, offset: 0, user_type: 2 }));
  }, [dispatch]);

  useEffect(() => {
    const { reportPropertyList, reportEmployeeList, reportCPNAMEList } =
      ReportListSelector;
    if (reportPropertyList) {
      setSitePropertyList(reportPropertyList.data);
    } else {
      setSitePropertyList([]);
    }
    if (reportEmployeeList) {
      setUserList(reportEmployeeList.data);
    } else {
      setUserList([]);
    }
    if (reportCPNAMEList) {
      setchannelPartnerList(reportCPNAMEList.data);
    } else {
      setchannelPartnerList([]);
    }
  }, [ReportListSelector]);

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
  };

  const handleSubmit = async () => {
    if (!handleValid()) {
      let send_type =
        form.select_user === "No"
          ? 1
          : form.select_cp === "No"
            ? 1
            : form.select_user === "Yes"
              ? 2
              : form.select_cp === "Yes"
                ? 2
                : 1;
      let user_ids =
        form.select_user === "Yes"
          ? form?.employee.map((i) => {
            return { user_id: i._id };
          })
          : form.select_cp === "Yes"
            ? form?.cpuser.map((i) => {
              return { user_id: i._id };
            })
            : [];
      let params = {
        property_id: form?.site?._id ? form?.site?._id : "",
        title: form.title,
        message: form.remark,
        user_type: form.preferred_type === "1" ? 1 : 2,
        send_type: send_type,
        user_id: user_ids,
      };
      const result = await dispatch(addUserAnnouncement(params));
      if (result.status === 200) {
        setForm({
          title: "",
          remark: "",
          site: "",
          employee: "",
          cpuser: "",
        });
      }
    }
  };

  const handleValid = () => {
    let err = {};
    let formError = false;
    if (
      String(form?.preferred_type) !== "1" &&
      String(form?.preferred_type) !== "2"
    ) {
      formError = true;
      err["preferred_type"] = strings.sendToErr;
    }
    if (String(form?.preferred_type) === "1") {
      if (
        String(form?.select_user) !== "Yes" &&
        String(form?.select_user) !== "No"
      ) {
        formError = true;
        err["select_user"] = strings.selectUserErr;
      }
    } else if (String(form?.preferred_type) === "2") {
      if (
        String(form?.select_cp) !== "Yes" &&
        String(form?.select_cp) !== "No"
      ) {
        formError = true;
        err["select_cp"] = strings.selectcpErr;
      }
    }
    if (String(form?.select_user) === "Yes") {
      if (!form?.employee) {
        formError = true;
        err["employee"] = strings.selectUserErr;
      }
    }
    if (String(form?.select_cp) === "Yes") {
      if (!form?.cpuser) {
        formError = true;
        err["cpuser"] = strings.selectcpErr;
      }
    }
    if (!form?.site) {
      formError = true;
      err["site"] = strings.propertyErr;
    }
    if (!form?.title) {
      formError = true;
      err["title"] = strings.titleErr;
    }
    if (!form?.remark) {
      formError = true;
      err["remark"] = strings.messageErr;
    }
    if (!isEmpty(formVaild)) {
      formError = true;
    }
    setFormVaild(err);
    return formError;
  };

  useEffect(() => {
    seo({
      title: "User Announcement",
      metaDescription: "User announcement",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.userAnnouncement}
        titleactive={strings.userAnnouncement}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.userAnnouncement}</h5>
              </div>
              <div className="card-body">
                <form>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="form-group mb-0">
                        <label htmlFor="exampleFormControlFirstName">
                          {strings.property}<span className="required-field"></span>
                        </label>
                        <Select
                          isSearchable
                          isClearable
                          onInputChange={(e) => {
                            if (e.length > 1) {
                              dispatch(
                                getReportPropertyList({
                                  search_site: e,
                                  isLoadMore: true,
                                })
                              );
                            } else {
                              dispatch(
                                getReportPropertyList({
                                  limit: 10,
                                  offset: 0,
                                  isLoadMore: true,
                                })
                              );
                            }
                          }}
                          placeholder={strings.selectproperty}
                          options={sitePropertyList}
                          getOptionLabel={(option) =>
                            `${option.property_title}`
                          }
                          getOptionValue={(option) => option._id}
                          name="site"
                          value={form.site}
                          onChange={(e) => {
                            setForm({ ...form, site: e });
                            dispatch(
                              getReportEmployeeList({
                                limit: 10,
                                offset: 0,
                                user_type: 1,
                                property_id: e._id,
                              })
                            );
                            dispatch(
                              getReportEmployeeList({
                                limit: 10,
                                offset: 0,
                                user_type: 2,
                                property_id: e._id,
                              })
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {formVaild?.site && (
                    <span style={{ color: "red" }}>
                      {formVaild?.site}
                    </span>
                  )}
                  <div className="row pt-2 pb-2">
                    <div className="col-md-12">
                      <div>
                        <label htmlFor="exampleFormControlLastName">
                          {strings.sendTo}
                          <span className="required-field"></span>
                        </label>
                        <div className="col">
                          <div className="form-group m-t-8 m-checkbox-inline mb-0 custom-radio-ml">
                            <div className="radio radio-primary mr-5">
                              <input
                                id="radioinline24"
                                type="radio"
                                name="preferred_type"
                                value={"1"}
                                checked={
                                  form.preferred_type === "1" ? true : false
                                }
                                onChange={(e) => {
                                  const nextFormState = {
                                    ...form,
                                    preferred_type: e.target.value,
                                    select_cp: "",
                                    cpuser: null,
                                  };
                                  setForm(nextFormState);
                                }}
                              />
                              <label className="mb-0" htmlFor="radioinline24">
                                {strings.justoUser}
                              </label>
                            </div>
                            <div className="radio radio-primary mr-5 ml-5">
                              <input
                                id="radioinline25"
                                type="radio"
                                name="preferred_type"
                                value={"2"}
                                checked={
                                  form.preferred_type === "2" ? true : false
                                }
                                onChange={(e) => {
                                  const nextFormState = {
                                    ...form,
                                    preferred_type: e.target.value,
                                    select_user: "",
                                    employee: null,
                                  };
                                  setForm(nextFormState);
                                }}
                              />
                              <label className="mb-0" htmlFor="radioinline25">
                                {strings.channelPartner}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {formVaild?.preferred_type && (
                    <span style={{ color: "red" }}>
                      {formVaild?.preferred_type}
                    </span>
                  )}
                  {form.preferred_type === "1" ? (
                    <>
                      <div className="row pt-2 pb-2">
                        <div className="col-md-12">
                          <div>
                            <label htmlFor="exampleFormControlLastName">
                              {strings.select}
                              <span className="required-field"></span>
                            </label>
                            <div className="col">
                              <div className="form-group m-t-8 m-checkbox-inline mb-0 custom-radio-ml">
                                <div className="radio radio-primary mr-5">
                                  <input
                                    id="radioinline29"
                                    type="radio"
                                    name="select_user"
                                    value={"Yes"}
                                    checked={
                                      form.select_user === "Yes" ? true : false
                                    }
                                    onChange={handleInputField}
                                  />
                                  <label
                                    className="mb-0"
                                    htmlFor="radioinline29"
                                  >
                                    {strings.selectedUser}
                                  </label>
                                </div>
                                <div className="radio radio-primary mr-5 ml-5">
                                  <input
                                    id="radioinline28"
                                    type="radio"
                                    name="select_user"
                                    value={"No"}
                                    checked={
                                      form.select_user === "No" ? true : false
                                    }
                                    onChange={handleInputField}
                                  />
                                  <label
                                    className="mb-0"
                                    htmlFor="radioinline28"
                                  >
                                    {strings.allUser}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : null}
                  {formVaild?.select_user && (
                    <span style={{ color: "red" }}>
                      {formVaild?.select_user}
                    </span>
                  )}

                  {form.select_user === "Yes" ? (
                    <>
                      <div className="row pt-3">
                        <div className="col-md-8">
                          <div>
                            <label htmlFor="exampleInputMobileNo">
                              {strings.justoUser}
                              <span className="required-field"></span>
                            </label>
                            <Select
                              isSearchable
                              isClearable
                              isMulti
                              onInputChange={(e) => {
                                if (e.length > 1) {
                                  dispatch(
                                    getReportEmployeeList({
                                      user_name: e,
                                      isLoadMore: true,
                                      user_type: 1,
                                      property_id: form?.site?._id,
                                    })
                                  );
                                } else {
                                  dispatch(
                                    getReportEmployeeList({
                                      limit: 10,
                                      offset: 0,
                                      isLoadMore: true,
                                      user_type: 1,
                                      property_id: form?.site?._id,
                                    })
                                  );
                                }
                              }}
                              placeholder={strings.SelectEmployee}
                              options={userList}
                              getOptionLabel={(option) => `${option.user_name}`}
                              getOptionValue={(option) => option._id}
                              name="employee"
                              value={form.employee}
                              onChange={(e) => {
                                setForm({ ...form, employee: e, cpuser: null });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  ) : null}
                  {formVaild?.employee && (
                    <span style={{ color: "red" }}>{formVaild?.employee}</span>
                  )}

                  {form.preferred_type === "2" ? (
                    <>
                      <div className="row pt-2 pb-2">
                        <div className="col-md-12">
                          <div>
                            <label htmlFor="exampleFormControlLastName">
                              {strings.select}
                              <span className="required-field"></span>
                            </label>
                            <div className="col">
                              <div className="form-group m-t-8 m-checkbox-inline mb-0 custom-radio-ml">
                                <div className="radio radio-primary mr-3">
                                  <input
                                    id="radioinline30"
                                    type="radio"
                                    name="select_cp"
                                    value={"Yes"}
                                    checked={
                                      form.select_cp === "Yes" ? true : false
                                    }
                                    onChange={handleInputField}
                                  />
                                  <label
                                    className="mb-0"
                                    htmlFor="radioinline30"
                                  >
                                    {strings.selectCP}
                                  </label>
                                </div>
                                <div className="radio radio-primary mr-5 ml-5">
                                  <input
                                    id="radioinline31"
                                    type="radio"
                                    name="select_cp"
                                    value={"No"}
                                    checked={
                                      form.select_cp === "No" ? true : false
                                    }
                                    onChange={handleInputField}
                                  />
                                  <label
                                    className="mb-0"
                                    htmlFor="radioinline31"
                                  >
                                    {strings.allCp}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : null}
                  {formVaild?.select_cp && (
                    <span style={{ color: "red" }}>{formVaild?.select_cp}</span>
                  )}

                  {form.select_cp === "Yes" ? (
                    <>
                      <div className="row pt-3">
                        <div className="col-md-8">
                          <div>
                            <label htmlFor="exampleInputMobileNo">
                              {strings.channelPartner}
                              <span className="required-field"></span>
                            </label>
                            <Select
                              isSearchable
                              isClearable
                              isMulti
                              onInputChange={(e) => {
                                if (e.length > 1) {
                                  dispatch(
                                    getReportEmployeeList({
                                      user_name: e,
                                      isLoadMore: true,
                                      user_type: 2,
                                      property_id: form?.site?._id,
                                    })
                                  );
                                } else {
                                  dispatch(
                                    getReportEmployeeList({
                                      limit: 10,
                                      offset: 0,
                                      isLoadMore: true,
                                      user_type: 2,
                                      property_id: form?.site?._id,
                                    })
                                  );
                                }
                              }}
                              placeholder={strings.selectCPName}
                              options={getchannelPartnerList}
                              getOptionLabel={(option) => `${option.user_name}`}
                              getOptionValue={(option) => option._id}
                              name="cpuser"
                              value={form.cpuser}
                              onChange={(e) => {
                                setForm({ ...form, cpuser: e, employee: null });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  ) : null}
                  {formVaild?.cpuser && (
                    <span style={{ color: "red" }}>{formVaild?.cpuser}</span>
                  )}

                  <div className="row pt-3">
                    <div className="col-md-8">
                      <div>
                        <label htmlFor="exampleFormControlInput1">
                          {strings.title}
                          <span className="required-field"></span>
                        </label>
                        <input
                          className="form-control"
                          id="exampleFormControlInput1"
                          type="text"
                          name="title"
                          value={form?.title}
                          placeholder={strings.title}
                          onChange={handleInputField}
                        />
                      </div>
                    </div>
                  </div>
                  {formVaild?.title && (
                    <span style={{ color: "red" }}>{formVaild?.title}</span>
                  )}

                  <div className="row pt-3">
                    <div className="col-md-8">
                      <div>
                        <label htmlFor="exampleFormControlLastName">
                          {strings.message}
                          <span className="required-field"></span>
                        </label>
                        <textarea
                          className="form-control"
                          name="remark"
                          value={form?.remark}
                          onChange={handleInputField}
                          id=""
                          cols="74"
                          rows="5"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  {formVaild?.remark && (
                    <span style={{ color: "red" }}>{formVaild?.remark}</span>
                  )}

                  <div className="row">
                    <div className="col-md-12 d-flex justify-content-end">
                      <div className="card-footer">
                        <button
                          onClick={() => handleSubmit()}
                          className="btn btn-color"
                          type="button"
                        >
                          {strings.submit}
                        </button>
                      </div>
                    </div>
                    {!isEmpty(formVaild) && (
                      <div className="col-md-12 float-right">
                        <span
                          style={{
                            color: "red",
                            float: "right",
                            // padding: "5px 15px 25px 5px",
                          }}
                        >
                          {strings.fieldRequired}
                        </span>
                      </div>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UserAnnouncement;
